import { render, staticRenderFns } from "./EmpleadoConfiguracionSeguridad.vue?vue&type=template&id=8c3afe76&scoped=true&"
import script from "./EmpleadoConfiguracionSeguridad.vue?vue&type=script&lang=js&"
export * from "./EmpleadoConfiguracionSeguridad.vue?vue&type=script&lang=js&"
import style0 from "./EmpleadoConfiguracionSeguridad.vue?vue&type=style&index=0&id=8c3afe76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3afe76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDivider,VForm,VImg,VRow,VTextField})
